import { DateTime } from 'luxon';
var AccountTier;
(function (AccountTier) {
    AccountTier["STANDARD"] = "standard";
    AccountTier["FREE"] = "free";
    AccountTier["CUSTOM"] = "custom";
    AccountTier["DEACTIVATED"] = "deactivated";
})(AccountTier || (AccountTier = {}));
const toAccountTier = (data) => {
    switch (data) {
        case 'standard':
            return AccountTier.STANDARD;
        case 'free':
            return AccountTier.FREE;
        case 'custom':
            return AccountTier.CUSTOM;
        case 'deactivated':
            return AccountTier.DEACTIVATED;
        default:
            return AccountTier.CUSTOM;
    }
};
const toAccountInfo = (data) => {
    return {
        tier: toAccountTier(data.tier),
        canOrder: data.canOrder ?? true
    };
};
const emptyAccountInfo = () => {
    return {
        tier: AccountTier.STANDARD,
        canOrder: true
    };
};
const emptyAccountPlan = (tier, credits, uid) => {
    return {
        startedAt: DateTime.now().toISO(),
        willEndAt: '',
        ordersCredit: credits,
        tier: tier,
        switchMadeByUid: uid,
        paymentProvider: '',
        paymentCustomerId: '',
        paymentSubscriptionId: '',
        lastPaymentAt: '',
        lastPaymentAmount: 0
    };
};
// The version of the Velpr terms (www.velpr.online/terms) currently in
// force. Bump it whenever the terms text changes; the signup sends the
// version it showed and the server rejects any other.
const TERMS_VERSION = '2026-10-14';
const emptyAccountDoc = () => {
    const now = DateTime.now();
    return {
        siteCreatedAt: now.toISO(),
        trialEndsAt: now.plus({ days: 14 }).toISO(),
        plan: {
            startedAt: now.toISO(),
            willEndAt: '',
            ordersCredit: 10,
            tier: AccountTier.CUSTOM,
            switchMadeByUid: '',
            paymentProvider: '',
            paymentCustomerId: '',
            paymentSubscriptionId: '',
            lastPaymentAt: '',
            lastPaymentAmount: 0
        },
        history: [],
        icalKey: '',
        termsAccepted: null
    };
};
const toAccountDoc = (data) => {
    if (!data)
        return emptyAccountDoc();
    const account = emptyAccountDoc();
    if (data.siteCreatedAt)
        account.siteCreatedAt = data.siteCreatedAt;
    if (data.trialEndsAt)
        account.trialEndsAt = data.trialEndsAt;
    if (data.plan) {
        account.plan.startedAt = data.plan.startedAt ?? '';
        account.plan.willEndAt = data.plan.willEndAt ?? '';
        account.plan.ordersCredit = data.plan.ordersCredit ?? 10;
        account.plan.tier = toAccountTier(data.plan.tier);
        account.plan.switchMadeByUid = data.plan.switchMadeByUid ?? '';
        account.plan.paymentProvider = data.plan.paymentProvider ?? '';
        account.plan.paymentCustomerId = data.plan.paymentCustomerId ?? '';
        account.plan.paymentSubscriptionId = data.plan.paymentSubscriptionId ?? '';
        account.plan.lastPaymentAt = data.plan.lastPaymentAt ?? '';
        account.plan.lastPaymentAmount = data.plan.lastPaymentAmount ?? 0;
    }
    if (data.history)
        account.history = data.history ?? [];
    account.icalKey = data.icalKey ?? '';
    if (data.termsAccepted) {
        account.termsAccepted = {
            version: data.termsAccepted.version ?? '',
            acceptedAt: data.termsAccepted.acceptedAt ?? '',
            uid: data.termsAccepted.uid ?? ''
        };
    }
    return account;
};
const accountIsActive = (doc) => {
    return doc.plan.tier !== AccountTier.DEACTIVATED;
};
const accountCanOrder = (doc, currentOrderCount) => {
    const trialEndsAtDt = DateTime.fromISO(doc.trialEndsAt || '1970-01-01');
    if (trialEndsAtDt > DateTime.now())
        return true;
    switch (doc.plan.tier) {
        case AccountTier.FREE:
            return doc.plan.ordersCredit > currentOrderCount;
        case AccountTier.STANDARD:
            return true;
        case AccountTier.CUSTOM:
            return true;
        case AccountTier.DEACTIVATED:
            return false;
    }
};
const accountReportUsage = (doc) => {
    switch (doc.plan.tier) {
        case AccountTier.FREE:
            return false;
        case AccountTier.STANDARD:
            return true;
        case AccountTier.CUSTOM:
            return false;
        case AccountTier.DEACTIVATED:
            return false;
    }
};
export { AccountTier, TERMS_VERSION, emptyAccountDoc, emptyAccountInfo, emptyAccountPlan, toAccountDoc, toAccountTier, toAccountInfo, accountIsActive, accountCanOrder, accountReportUsage };
//# sourceMappingURL=account.js.map